<template>
    <v-container>
        <v-tabs>
            <v-tab> Administración de Usuarios </v-tab>
            <v-tab-item> <UserAdministrationView/> </v-tab-item>
            <v-tab> Acceso a Cuentas </v-tab>
            <v-tab-item> <UserAccountAdministrationView/></v-tab-item>
        </v-tabs>
    </v-container>
</template>

<script>

import UserAdministrationView from '@/components/UserAdministrationView.vue';
import UserAccountAdministrationView from '@/components/UserAccountAdministrationView.vue';

export default {
    name : 'UserManagementView',

    components : {
        UserAdministrationView,
        UserAccountAdministrationView,
    },

    data : () => ({
    }),

    created() {
    },

    destroyed() {
    },

    computed : {
    },

    methods : {
    },
};

</script>
